module.exports = __webpack_public_path__ + "static/media/Blue_Dolphin.62a4dc99.svg";